import React, {useEffect, useRef, useState} from 'react';
import {Button} from "primereact/button";
import {SelectButton} from "primereact/selectbutton";

import {ProductService} from '../../service/ProductService';
import {ScraperService} from '../../service/ScraperService';
import {DynamicPricingTemplateService} from '../../service/DynamicPricingTemplateService';


import CompetitorSuggestion from "./CompetitorSuggestion";
import Competitor from "./Competitor";
import Supplier from "./Supplier";
import SupplierSuggestion from "./SupplierSuggestion";

import ProductReprice from "./ProductReprice";
import ProductDynamicPricingAuditHistory from "../Pricing/ProductDynamicPricingAuditHistory";

import queryString from "query-string";

import {
    formValid,
    getHostName,
    isAdmin,
    isCampaignMarketSearch,
    populateInactiveSellers,
    stripTrackingParams,
    userId,
} from "../../utils/Utils";
import ProductPriceViolation from "./ProductPriceViolation";
import {GlobalHotKeys} from "react-hotkeys";
import ProductAdminAction from "./ProductAdminAction";
import ProductSearchDiagnosticsTabs from "./ProductSearchDiagnosticsTabs";
import {TabMenu} from "primereact/tabmenu";
import ProductPriceGraph from "./ProductPriceGraph";
import ProductSaleGraph from "./ProductSaleGraph";
import DetailHeader from "./DetailHeader";
import DecisionHero from "./DecisionHero";
import {resolveProfile, profileTabKeys, tabIcon} from "./productDetailProfile";
import {AppContext} from "../../HomePage";
import {getWeeksAgo} from "../../utils/TimeUtil";
import {Loading, ProductNotFound} from "../../utils/InlineComponents";
import {CampaignContext} from "../../App";
import {job_states} from "../../utils/Constants";
import ProductEdit from "./ProductEdit";
import {Sidebar} from "primereact/sidebar";

const ProductDetail = (props) => {

    const {t, toast, setError, location} = React.useContext(AppContext);
    const {campaigns} = React.useContext(CampaignContext);

    const [loading, setLoading] = useState(false);
    const [product_id, setProductID] = useState("");
    const [selectedProduct, setSelectedProduct] = useState(null);
    // Map of repricing rule (template) id -> name, to label the applied rule in
    // the hero. Fetched once; the user's rule list is small and shared.
    const [templateNameById, setTemplateNameById] = useState({});
    const [highlightCompetitorUrl, setHighlightCompetitorUrl] = useState(null);
    // Preview deep-link: show ONLY these suggestion urls in the Suggestions tab.
    const [affectedSuggestionUrls, setAffectedSuggestionUrls] = useState(null);

    const loadSelectedCampaign = (selectedProduct) => {
        let campaign = {...campaigns.find(c=> c.id===selectedProduct?.campaign_id)}
        populateInactiveSellers([campaign])
        return campaign
    }

    let selectedCampaign = selectedProduct ? loadSelectedCampaign(selectedProduct) : null;

    const myProduct = () => {
        let myProduct = selectedProduct.competitors.some(competitor => {return competitor.is_mine}) ? selectedProduct.competitors.find(competitor => competitor.is_mine) : null;
        if (isCampaignMarketSearch(selectedCampaign) && selectedProduct.competitors.length > 0)
        {
            myProduct = selectedProduct.competitors[0];
        }
        return myProduct;
    }
    const competitors = () => {

        let competitors = selectedProduct.competitors.some(competitor => {return !competitor.is_mine}) ? selectedProduct.competitors.filter(competitor => !competitor.is_mine) : [];

        if (isCampaignMarketSearch(selectedCampaign) && selectedProduct.competitors.length > 0)
            competitors = selectedProduct.competitors.slice(1);

        return competitors;
    }
    const [activeTabKey, setActiveTabKey] = useState(props.initialTab || 'sellers');
    const [historyView, setHistoryView] = useState('price'); // 'price' | 'sale'
    const [intervalId, setIntervalId] = useState(null);
    const competitorActionsRef = useRef({});

    const [notFound, setNotFound] = useState(false);
    const [showEdit, setShowEdit] = useState(false);

    const productService = new ProductService();
    const scraperService = new ScraperService();

    // Load the user's repricing rules once to resolve the applied rule's name
    // for the hero card.
    useEffect(() => {
        new DynamicPricingTemplateService().list().then(list => {
            const map = {};
            (list || []).forEach(tpl => { map[tpl.id] = tpl.name; });
            setTemplateNameById(map);
        }).catch(() => {});
    }, []);

    useEffect(() => {

        if (location)
        {
            let params = queryString.parse(location.search);
            if (params && params.id && params.id !== "") {
                setHighlightCompetitorUrl(params.highlight_competitor_url ? params.highlight_competitor_url : null);
                if (params.tab) {
                    setActiveTabKey(params.tab);
                }
                if (params.affected) {
                    try {
                        setAffectedSuggestionUrls(JSON.parse(atob(params.affected)));
                    } catch (e) {
                        setAffectedSuggestionUrls(null);
                    }
                }
                setLoading(true);
                getProduct(params.id).then(() => {
                    setLoading(false);
                });
            }
        }

        let intervalId = setInterval(refreshProducts, 15000);
        setIntervalId(intervalId);


        return () => {
            clearInterval(intervalId);
            setIntervalId(null);
        }

    }, []);

    useEffect(() => {
        if (props.product_id && props.product_id !== "") {
            setLoading(true);
            getProduct(props.product_id).then(() => {
                setLoading(false);
            });
        }
    },[props.product_id]);

    const profile = selectedProduct ? resolveProfile(selectedCampaign) : null;

    // Pending suggestion count for the badge on the Suggestions tab.
    const pendingSuggestions = () => selectedProduct && selectedProduct.competitor_suggestions
        ? selectedProduct.competitor_suggestions.filter(s => s.is_match_decision_made === false).length : 0;
    // Same badge, for the supplier suggestions tab.
    const pendingSupplierSuggestions = () => selectedProduct && selectedProduct.supplier_suggestions
        ? selectedProduct.supplier_suggestions.filter(s => s.is_match_decision_made === false).length : 0;
    const SUGGESTION_TAB_KEYS = ['suggestions', 'supplier_suggestions'];
    const pendingCountByTabKey = {suggestions: pendingSuggestions, supplier_suggestions: pendingSupplierSuggestions};

    const tabLabel = {
        overview: () => t('product_detail.overview', 'Overview'),
        sellers: () => t('product_detail.competitors'),
        suppliers: () => t('product_detail.suppliers', 'Suppliers'),
        suggestions: () => t('product_detail.suggested_competitors'),
        supplier_suggestions: () => t('product_detail.suggested_suppliers'),
        history: () => t('product_detail.price_history'),
        pricing: () => t('product_detail.repricing'),
        compliance: () => t('product_detail.price_violation'),
        search: () => t('product_detail.search_diagnostics', 'Search Diagnostics'),
        admin: () => t('product_detail.product_admin_action'),
    };
    // Marketplace API (buybox) campaigns source their competitors from the
    // marketplace API rather than manual URL matching, so the
    // competitor-suggestion matching tab is meaningless for them -- see
    // buildTabModel below.
    const isMarketplaceBuybox = (c) => !!c?.settings?.marketplace_api;
    const buildTabModel = () => {
        if (!selectedProduct) return [];
        return profileTabKeys(selectedCampaign)
            .filter(key => key !== 'suggestions' || !isMarketplaceBuybox(selectedCampaign))
            .map(key => {
                const count = SUGGESTION_TAB_KEYS.includes(key) ? pendingCountByTabKey[key]() : 0;
                const label = <span style={{whiteSpace:'nowrap'}}>{tabLabel[key]()}
                    {count > 0 && <span style={{marginLeft:'.4em', background:'#ef4444', color:'#fff',
                        borderRadius:'999px', padding:'.05em .5em', fontSize:'.72rem', verticalAlign:'middle'}}>{count}</span>}</span>;
                // count is only ever non-zero for a suggestion tab (see above), so
                // this covers both the spinner-while-pending case and every other
                // tab's static icon in one check.
                const icon = count > 0 ? 'pi pi-spin pi-spinner' : tabIcon[key];
                return {key, label, icon};
            });
    };
    const tabModel = buildTabModel();
    // If activeTabKey still points at the excluded 'suggestions' tab (e.g. a
    // stale deep link, or the product-list "suggestions" quick action), fall
    // back to the first available tab instead of rendering the excluded panel.
    const effectiveActiveTabKey = (activeTabKey === 'suggestions' && isMarketplaceBuybox(selectedCampaign))
        ? (tabModel[0]?.key || activeTabKey)
        : activeTabKey;
    const activeIndex = Math.max(0, tabModel.findIndex(tm => tm.key === effectiveActiveTabKey));

    const getProduct = async (id) => {

        return productService.getProduct(id).then(product => {

            if (userId() !== product.user_id && !(isAdmin() || userId() === "3ba409bd-3b0a-4b53-9852-468b0bce9952"))
            {
                setNotFound(true);
                throw 'Not Found';
            }
            else
                setNotFound(false);
            setSelectedProduct({...product});
            setProductID(id);
            return product;
        }).then(product => {
            productService.getCompetitors(id, getWeeksAgo(2), new Date()).then(competitors=>{
                product.competitors = competitors;
                setSelectedProduct({...product});
            }).catch(error =>{
                setError(error);
                setError(null);
            })
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    }

    const refreshProducts = () => {
        let product = selectedProduct;

        if ((product && product.competitor_suggestion_scraping_request && (product.competitor_suggestion_scraping_request.state === job_states.todo || product.competitor_suggestion_scraping_request.state === job_states.in_progress)) ||
            (product && product.scraping_request && (product.scraping_request.state === job_states.todo || product.scraping_request.state === job_states.in_progress)) ||
            (product && product.competitors.length !== 0 && product.competitors.some(competitor => {return competitor.scraping_request && (competitor.scraping_request.state === job_states.todo || competitor.scraping_request.state === job_states.in_progress)})))
        {
            getProduct(product.id).then(()=>{});
        }
    }

    const refreshProductsMust = () => {
        getProduct(selectedProduct.id).then(()=>{});
    };

    function back()  {
        if (props.product_id !== undefined && props.product_id !== null && props.product_id !== ""){
            if (intervalId) {
                clearInterval(intervalId);
                setIntervalId(null);
            }
            props.onDetailComplete();
        }
    };

    function previous() {
        if (props.product_id !== undefined && props.product_id !== null && props.product_id !== "") {
            if (intervalId) {
                clearInterval(intervalId);
                setIntervalId(null);
            }
            props.goToPrevious();
        }
    };
    function next() {
        if (props.product_id !== undefined && props.product_id !== null && props.product_id !== "") {
            if (intervalId) {
                clearInterval(intervalId);
                setIntervalId(null);
            }
            props.goToNext();
        }
    };

    //#region Brief

    const autoMatchProductSuggestions = (match_method, min_match_score) => {

        if (match_method !== "sku" && match_method !== "mpn" && match_method !== "ean" &&
            match_method !== "upc" && match_method !== "barcode" &&
            match_method !== "name_exact" && match_method !== "name_in" && match_method !== "match_score" )
        {
            toast.current.show({severity: 'error', summary: t('suggestion.select_match_method'), detail: ""});
            return;
        }

        productService.autoMatchProductSuggestions(product_id, match_method, min_match_score).then(()=>{
            getProduct(product_id);
            toast.current.show({severity: 'success', summary: t('actions.auto_match_suggestions'), detail: t('message_detail.successful')});
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    };

    const searchCompetitorsOnWebsite = () => {

        scraperService.saveScrapingRequest({type: "site_search_product", campaign_id: selectedProduct.campaign_id, product_id: product_id}).then(()=>{
            toast.current.show({severity: 'success', summary: t('actions.search_competitors_on_website'), detail: t('message_detail.successful')});
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    };

    const getShippingPrices = () => {

        scraperService.getShippingPrices({
            spider_name: "prices_product_update",
            type: "shipping_price",
            campaign_id: selectedProduct.campaign_id,
            product_id: selectedProduct.id,
        }).then(() => {
            toast.current.show({severity: 'success', summary: t('actions.get_shipping_price'), detail: t('message_detail.successful')});
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    }

    const getProductReviews = () => {
        scraperService.saveScrapingRequest({
            spider_name: "product_update_review",
            type: "products_update_partial",
            fields: ["reviews"],
            campaign_id: selectedProduct.campaign_id,
            product_id: selectedProduct.id,
        }).then(() => {
            toast.current.show({severity: 'success', summary: t('actions.get_product_reviews'), detail: t('message_detail.successful')});
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    }

    const getProductFailedReviews = () => {
        scraperService.saveScrapingRequest({
            spider_name: "product_update_failed_review",
            type: "products_update_partial",
            fields: ["reviews"],
            campaign_id: selectedProduct.campaign_id,
            product_id: selectedProduct.id,
        }).then(() => {
            toast.current.show({severity: 'success', summary: t('actions.get_product_failed_reviews'), detail: t('message_detail.successful')});
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    }

    //#endregion Brief

    //##region RePricing

    const savePricingStrategy = async (pricing_strategy, keepTemplate = false) => {

        return productService.savePricingStrategy(selectedProduct.id, pricing_strategy, keepTemplate).then(result => {

            let product = selectedProduct;
            product.suggested_price = result.suggested_price;
            product.target_price = result.target_price;
            product.pricing_strategy = pricing_strategy;
            setSelectedProduct({...product});

            toast.current.show({
                severity: 'success',
                summary: t('reprice.save_pricing_strategy'),
                detail: t('message_detail.successful')
            });
        }).catch(error => {
            setError(error);
            setError(null);
        });
    };

    const savePriceViolation = (violation_strategy) => {
        productService.savePriceViolation(selectedProduct.id, violation_strategy).then(r => {

            let product = selectedProduct;
            product.violation_strategy = r.violation_strategy;

            setSelectedProduct(product);

            toast.current.show({
                severity: 'success',
                summary: t('product_detail.save_violation_strategy'),
                detail: t('message_detail.successful')
            });

        }).catch(error => {
            setError(error);
            setError(null);
        });

    };

    //#endregion RePricing

    //#region Competitor

    const addCompetitorFromSuggestions = (urls, formErrors) => {

        if (formValid(formErrors)) {

            let competitors = [];
            let product = selectedProduct;

            let is_exists = false;
            urls.forEach(url => {

                is_exists = product.competitors.some(competitor => competitor.product_url.toLowerCase() === url.product_url.toLowerCase());

                if (is_exists) {
                    toast.current.show({
                        severity: 'warn',
                        summary: t('product_detail.product_exist_summary'),
                        detail: t('product_detail.product_exist_detail')
                    });
                    return;
                }

                competitors.push({
                    id: "",
                    product_url: url.product_url,
                    name: getHostName(url.product_url),
                    is_mine: false,
                    prices: [],
                    scraping_request: null
                });
            });

            if (!is_exists){

                productService.addCompetitorFromSuggestions(product.id, competitors).then(result => {

                    let suggestions = product.competitor_suggestions;

                    competitors.forEach(competitor => {
                        if (suggestions)
                        {
                            let index = suggestions.findIndex(suggestion => suggestion.product_url.toLowerCase() === competitor.product_url.toLowerCase());
                            if (index !== -1) {
                                suggestions[index].is_match_decision_made = true;
                                suggestions[index].is_matched = true;
                            }
                        }

                    });

                    competitors.forEach(competitor => product.competitors.push(competitor));
                    product.competitor_suggestions = suggestions;

                    setSelectedProduct({...product});

                    toast.current.show({
                        severity: 'success',
                        summary: t('product_detail.add_competitor'),
                        detail: t('message_detail.successful')
                    });

                }).catch(error => {
                    setError(error);
                    setError(null);
                });
            }
        }

    };


    const addCompetitor = (urls, formErrors) => {

        if (formValid(formErrors)) {

            let competitors = [];
            let product = selectedProduct;

            let is_exists = false;
            urls.forEach(url => {

                // Drop ad click ids (srsltid, gclid, utm_*, ...) so the stored URL stays clean.
                url = {...url, product_url: stripTrackingParams(url.product_url)};

                is_exists = product.competitors.some(competitor => competitor.product_url.toLowerCase() === url.product_url.toLowerCase());

                if (is_exists) {
                    toast.current.show({
                        severity: 'warn',
                        summary: t('product_detail.product_exist_summary'),
                        detail: t('product_detail.product_exist_detail')
                    });
                    return;
                }

                competitors.push({
                    id: "",
                    product_url: url.product_url,
                    name: getHostName(url.product_url),
                    is_mine: false,
                    prices: [],
                    scraping_request: null,
                    is_active: true,
                    // A seller added with a typed price: pricerest stores it out of the automatic checks.
                    ...(url.manual_price ? {manual_price: url.manual_price, product_name: url.product_name,
                        is_manual_price: true,
                        prices: [{value: url.manual_price.added_price, currency: url.manual_price.added_currency,
                                  stock: url.manual_price.added_stock, created_at: new Date(), is_manual: true}]} : {})
                });
            });

            if (!is_exists){

                productService.addCompetitor(product.id, competitors).then(result => {

                    let suggestions = product.competitor_suggestions;

                    let scrapingRequests = [];

                    if (result && !Array.isArray(result))
                        scrapingRequests[0] = result;
                    else if (result)
                        scrapingRequests = result;
                    //Returns the related scraping request as result


                    competitors.forEach(competitor => {
                        let index = scrapingRequests.findIndex(scrapingRequest => scrapingRequest.competitor_url && competitor.product_url.toLowerCase() === scrapingRequest.competitor_url.toLowerCase());
                        if (index !== -1)
                            competitor.scraping_request = scrapingRequests[index];

                        if (suggestions)
                        {
                            let index = suggestions.findIndex(suggestion => suggestion.product_url.toLowerCase() === competitor.product_url.toLowerCase());
                            if (index !== -1) {
                                suggestions[index].is_match_decision_made = true;
                                suggestions[index].is_matched = true;
                            }
                        }

                    });


                    /*scrapingRequests.forEach(scrapingRequest=>{
                        if (scrapingRequest.competitor_url)
                        {
                            let index = competitors.findIndex(competitor => competitor.product_url.toLowerCase() === scrapingRequest.competitor_url.toLowerCase());
                            if (index !== -1)
                                competitors[index].scraping_request = scrapingRequest;

                            if (suggestions)
                            {
                                let index = suggestions.findIndex(suggestion => suggestion.product_url.toLowerCase() === scrapingRequest.competitor_url.toLowerCase());
                                if (index !== -1) {
                                    suggestions[index].is_match_decision_made = true;
                                    suggestions[index].is_matched = true;
                                }
                            }
                        }
                    });*/
                    competitors.forEach(competitor => product.competitors.push(competitor));
                    product.competitor_suggestions = suggestions;

                    setSelectedProduct({...product});

                    toast.current.show({
                        severity: 'success',
                        summary: t('product_detail.add_competitor'),
                        detail: t('message_detail.successful')
                    });

                }).catch(error => {
                    setError(error);
                    setError(null);
                });
            }
        }

    };



    const changeCompetitorIsActive = async (product_urls, is_active) => {

        return productService.updateCompetitorIsActive(selectedProduct.id, product_urls, is_active).then(() => {
            let competitors = selectedProduct.competitors;

            product_urls.forEach(product_url=>{
                let index = competitors.findIndex(competitor => competitor.product_url === product_url);
                // Mirror what the endpoint did rather than flipping the stored flag:
                // an unset is_active reads as falsy here but counts as active on the
                // backend, so flipping it would show the row's state inverted.
                competitors[index].is_active = !is_active;
            });

            selectedProduct.competitors = competitors;
            setSelectedProduct({...selectedProduct});

            toast.current.show({severity: 'success', summary: is_active ? t('product.comp_deactivated') : t('product.comp_activated'), detail: t('message_detail.successful')})
        }).catch(error =>{
            setError(error);
            setError(null);
        });

    }

    const changeCompetitorIsDynamicPricingActive = async (product_urls, is_active) => {

        return productService.updateCompetitorIsDynamicPricingActive(selectedProduct.id, product_urls, is_active).then(() => {
            let competitors = selectedProduct.competitors;

            product_urls.forEach(product_url=>{
                let index = competitors.findIndex(competitor => competitor.product_url === product_url);
                competitors[index].is_dynamic_pricing_active = !competitors[index].is_dynamic_pricing_active;
            });

            selectedProduct.competitors = competitors;
            setSelectedProduct({...selectedProduct});

            toast.current.show({severity: 'success', summary: is_active ? t('actions.exclude') : t('actions.include'), detail: t('message_detail.successful')})
        }).catch(error =>{
            setError(error);
            setError(null);
        });

    }

    const deleteCompetitor = async (product_urls) => {

        return productService.deleteCompetitor(selectedProduct.id, product_urls).then(() => {
            selectedProduct.competitors = selectedProduct.competitors.filter(competitor => !product_urls.includes(competitor.product_url));
            setSelectedProduct({...selectedProduct});

            // if (selectedProduct.competitor_suggestions)
            // {
            //     let suggestions = selectedProduct.competitor_suggestions;
            //
            //     let index = suggestions.findIndex(suggestion => suggestion.product_url.toLowerCase() === rowData.product_url.toLowerCase());
            //     if (index !== -1) {
            //         suggestions[index].is_match_decision_made = true;
            //         suggestions[index].is_matched = false;
            //
            //         selectedProduct.competitor_suggestions = suggestions;
            //         setSelectedProduct({...selectedProduct});
            //     }
            // }

            toast.current.show({severity: 'success', summary: t('product_detail.remove_competitor'), detail: t('message_detail.successful')});
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    }

    const ignoreCompetitorSuggestion = (competitor_suggestions) => {
        productService.ignoreCompetitor(selectedProduct.id, competitor_suggestions).then(() => {

            let suggestions = selectedProduct.competitor_suggestions;
            competitor_suggestions.forEach(new_suggestion=>{
                let index = suggestions.findIndex(suggestion => suggestion.product_url.toLowerCase() === new_suggestion.product_url.toLowerCase());
                suggestions[index].is_match_decision_made = true;
                suggestions[index].is_matched = false;
            });

            selectedProduct.competitor_suggestions = suggestions;
            setSelectedProduct({...selectedProduct});

            toast.current.show({severity: 'success', summary: t('actions.mark_not_competitor'), detail: t('message_detail.successful')});
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    }

    const updateCompetitor = (data) => {
        productService.updateCompetitorFields(selectedProduct.id, data).then(result => {
            let product = selectedProduct;

            let comp = product.competitors[product.competitors.findIndex(competitor => competitor.product_url === data.competitor_url)];
            // multiplier is the effective one the API resolved (it may come from
            // the seller or the site); url_multiplier is this URL's own value.
            comp.multiplier = result.multiplier
            comp.url_multiplier = result.url_multiplier
            comp.discount_type = data.discount_type
            comp.manual_shipping_price = data.manual_shipping_price
            comp.manual_shipping_price_threshold = data.manual_shipping_price_threshold
            comp.prices.push(result.prices[0])
            if (result.shipping_prices !== null) {
                if (!comp.shipping_prices)
                    comp.shipping_prices = []
                comp.shipping_prices.push(result.shipping_prices[0])
            }

            setSelectedProduct({...product});
            toast.current.show({severity: 'success', summary: t('product_detail.edit_competitor'), detail: t('message_detail.successful')});
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    }


    const matchCompetitorVariant = (competitor_url, variants) => {

        productService.matchCompetitorVariant(selectedProduct.id, competitor_url, variants).then(() => {

            let product = selectedProduct;

            product.competitors[product.competitors.findIndex(competitor => competitor.product_url === competitor_url)].selected_variant = variants;

            setSelectedProduct(product);
            toast.current.show({severity: 'success', summary: t('product_detail.select_variant'), detail: t('message_detail.successful')});

            const newRequest = {
                campaign_id: selectedProduct.campaign_id,
                product_id: selectedProduct.id,
                url: competitor_url,
                competitor_url: competitor_url,
                type: 'price_competitor_update'
            };

            scraperService.saveScrapingRequest(newRequest).then(()=>{
                getProduct(selectedProduct.id);
            }).catch(error =>{
                setError(error);
                setError(null);
            });

        }).catch(error =>{
            setError(error);
            setError(null);
        });
    }

    //#endregion Competitor

    //#region Supplier

    const addSupplier = (product_url) => {

        const cleanUrl = stripTrackingParams(product_url);
        const suppliers = selectedProduct.suppliers || [];

        const alreadyExists = suppliers.some(supplier => supplier.product_url.toLowerCase() === cleanUrl.toLowerCase());
        if (alreadyExists) {
            toast.current.show({
                severity: 'warn',
                summary: t('product_detail.product_exist_summary'),
                detail: t('product_detail.product_exist_detail')
            });
            return;
        }

        // suppliers/add also returns the scraping request it created, but
        // nothing reads it off the row any more: the check-price control is
        // product-scoped now (Supplier.js polls suppliers/last_check_price
        // for the product's own true state), not per-source.
        productService.addSupplier(selectedProduct.id, cleanUrl).then(() => {

            const newSource = {
                id: "",
                product_url: cleanUrl,
                name: getHostName(cleanUrl),
                prices: []
            };

            selectedProduct.suppliers = [...suppliers, newSource];
            setSelectedProduct({...selectedProduct});

            toast.current.show({severity: 'success', summary: t('supplier.add_source'), detail: t('message_detail.successful')});

        }).catch(error => {
            setError(error);
            setError(null);
        });
    };

    const changeSupplierIsActive = async (product_urls, is_active) => {

        return productService.updateSupplierIsActive(selectedProduct.id, product_urls, is_active).then(() => {
            let suppliers = selectedProduct.suppliers;

            product_urls.forEach(product_url => {
                let index = suppliers.findIndex(supplier => supplier.product_url === product_url);
                // Same inversion as changeCompetitorIsActive: mirror what the
                // endpoint did rather than flipping the stored flag, since an
                // unset is_active reads as falsy here but counts as active on
                // the backend.
                suppliers[index].is_active = !is_active;
            });

            selectedProduct.suppliers = suppliers;
            setSelectedProduct({...selectedProduct});

            toast.current.show({severity: 'success', summary: is_active ? t('product.comp_deactivated') : t('product.comp_activated'), detail: t('message_detail.successful')});
        }).catch(error => {
            setError(error);
            setError(null);
        });

    };

    const deleteSupplier = async (product_urls) => {

        return productService.deleteSupplier(selectedProduct.id, product_urls).then(() => {
            selectedProduct.suppliers = selectedProduct.suppliers.filter(supplier => !product_urls.includes(supplier.product_url));
            setSelectedProduct({...selectedProduct});

            toast.current.show({severity: 'success', summary: t('product_detail.remove_competitor'), detail: t('message_detail.successful')});
        }).catch(error => {
            setError(error);
            setError(null);
        });
    };

    const updateSupplier = (data) => {
        productService.updateSupplierFields(selectedProduct.id, data).then(result => {
            let product = selectedProduct;

            let supplier = product.suppliers[product.suppliers.findIndex(s => s.product_url === data.competitor_url)];
            supplier.product_url = result.product_url;
            supplier.multiplier = result.multiplier;
            supplier.discount_type = result.discount_type;
            // Mirrors updateCompetitor: the endpoint restamps the row's last
            // price (recalculated for the new multiplier) with a fresh
            // created_at, so it lands as a new point in the price history.
            if (result.prices && result.prices.length > 0)
                supplier.prices.push(result.prices[0]);

            setSelectedProduct({...product});
            toast.current.show({severity: 'success', summary: t('supplier.edit_seller'), detail: t('message_detail.successful')});
        }).catch(error => {
            setError(error);
            setError(null);
        });
    };

    //#endregion Supplier


    const keyMap = {
        back: "backspace",
        previous: "ArrowLeft",
        next: "ArrowRight",
    };

    const handlers = {
        back: event => {back()},
        previous: event => {previous()},
        next: event => {next()}
    };

    const update = (product) =>{

        productService.updateProduct(product.id, product).then(updatedProduct => {
            selectedProduct.name = product.name;
            selectedProduct.brand = product.brand;
            selectedProduct.category = product.category;
            selectedProduct.barcode = product.barcode;
            selectedProduct.sku = product.sku;
            selectedProduct.mpn = product.mpn;
            selectedProduct.ean = product.ean;
            selectedProduct.upc = product.upc;
            selectedProduct.ref_id = product.ref_id;
            selectedProduct.vat = product.vat;
            selectedProduct.search_key = product.search_key;
            selectedProduct.properties = product.properties;
            selectedProduct.campaign_id = product.campaign_id;
            selectedProduct.is_active = product.is_active;

            setSelectedProduct({...selectedProduct});
            setShowEdit(false);

            toast.current.show({
                severity: 'success',
                summary: t('product.edit_product'),
                detail: t('message_detail.successful')
            });
        }).catch(error => {
            setError(error);
            setError(null);
        });
    }

    const changeIsActive = () => {
        productService.updateProductIsActive(selectedProduct.id, selectedProduct.is_active).then(() => {
            setSelectedProduct({...selectedProduct, is_active:!selectedProduct.is_active});
            toast.current.show({severity: 'success', summary: selectedProduct.is_active ? t('product.activated') : t('product.deactivated'), detail: t('message_detail.successful')})
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    };

    const getCompetitors = async (id, startdate, enddate) => {

        return productService.getCompetitors(id, startdate, enddate).then(competitors=>{
            selectedProduct.competitors = competitors;
            setSelectedProduct({...selectedProduct});
        }).catch(error =>{
            setError(error);
            setError(null);
        })

    }

    return loading ?
            <div className="card" style={{textAlign:'center'}}>
            <Loading/>
        </div>
        :  notFound ? <ProductNotFound/> :
            <React.Fragment>

                {selectedProduct !== null ?
                    <GlobalHotKeys keyMap={keyMap} handlers={handlers}>
                        <div className="card">

                            <Sidebar showCloseIcon={false} visible={showEdit} style={{width:'40em', maxWidth:'95vw', overflow:"auto"}} position="right" onHide={() => setShowEdit(false)}>
                                <ProductEdit selectedProduct={selectedProduct} categories={[]} brands={[]}
                                             cancel={() => setShowEdit(false)} update={update}/>
                            </Sidebar>

                            <DetailHeader t={t} selectedProduct={selectedProduct}
                                          onToggleActive={changeIsActive} onEdit={() => setShowEdit(true)}
                                          onRefresh={refreshProductsMust}
                                          onBack={back} onPrev={previous} onNext={next}
                                          showNav={!!props.product_id}/>

                            <DecisionHero t={t} profile={profile} selectedProduct={selectedProduct}
                                          selectedCampaign={selectedCampaign}
                                          appliedTemplateName={selectedProduct && selectedProduct.pricing_template_id
                                              ? templateNameById[selectedProduct.pricing_template_id] : null}
                                          myProduct={myProduct()} competitors={competitors()}
                                          onPrimaryAction={(key) => setActiveTabKey(key)}/>

                            <TabMenu model={tabModel} activeIndex={activeIndex}
                                     onTabChange={(e) => setActiveTabKey(e.value.key)}
                                     style={{paddingTop:0, paddingLeft:0, paddingRight:0}}/>

                            <div className="p-col-12" style={{paddingLeft:0, paddingRight:0}}>
                                <br/>
                                {effectiveActiveTabKey === 'history' && <>
                                    <SelectButton value={historyView}
                                        options={[
                                            {label: t('product_detail.price_history'), value: 'price'},
                                            {label: t('product_detail.sale_history'), value: 'sale'},
                                        ]}
                                        onChange={(e) => { if (e.value) setHistoryView(e.value); }}/>
                                    <br/><br/>
                                    {historyView === 'price'
                                        ? <ProductPriceGraph selectedProduct={selectedProduct} getCompetitors={getCompetitors}/>
                                        : <ProductSaleGraph selectedProduct={selectedProduct}/>}
                                </>}

                                {effectiveActiveTabKey === 'pricing' && <>
                                    <ProductReprice selectedProduct={selectedProduct} savePricingStrategy={savePricingStrategy}/>
                                    <ProductDynamicPricingAuditHistory t={t} productId={selectedProduct.id}/>
                                </>}

                                {effectiveActiveTabKey === 'compliance' &&
                                    <ProductPriceViolation selectedProduct={selectedProduct} savePriceViolation={savePriceViolation}/>}

                                {effectiveActiveTabKey === 'sellers' &&
                                    <Competitor selectedProduct={selectedProduct} myProduct={myProduct()} competitors={competitors()}
                                                profile={profile}
                                                addCompetitor={addCompetitor} changeCompetitorIsActive={changeCompetitorIsActive}
                                                changeCompetitorIsDynamicPricingActive={changeCompetitorIsDynamicPricingActive}
                                                deleteCompetitor={deleteCompetitor} matchCompetitorVariant={matchCompetitorVariant}
                                                updateCompetitor={updateCompetitor} highlightCompetitorUrl={highlightCompetitorUrl}
                                                refreshProducts={refreshProductsMust} actionsRef={competitorActionsRef}/>}

                                {effectiveActiveTabKey === 'suppliers' &&
                                    <Supplier selectedProduct={selectedProduct} campaign={selectedCampaign}
                                              addSupplier={addSupplier} changeSupplierIsActive={changeSupplierIsActive}
                                              deleteSupplier={deleteSupplier} updateSupplier={updateSupplier}
                                              refreshProducts={refreshProductsMust}/>}

                                {effectiveActiveTabKey === 'supplier_suggestions' &&
                                    <SupplierSuggestion selectedProduct={selectedProduct}
                                                         refreshProducts={refreshProductsMust}/>}

                                {effectiveActiveTabKey === 'suggestions' &&
                                    <CompetitorSuggestion selectedProduct={selectedProduct}
                                                          addCompetitor={addCompetitorFromSuggestions}
                                                          ignoreCompetitorSuggestion={ignoreCompetitorSuggestion}
                                                          affectedUrls={affectedSuggestionUrls}
                                                          clearAffectedUrls={() => setAffectedSuggestionUrls(null)}
                                                          campaignProfile={selectedCampaign && selectedCampaign.settings && selectedCampaign.settings.matching_profile}
                                                          refreshProducts={refreshProductsMust}/>}

                                {effectiveActiveTabKey === 'search' && isAdmin() &&
                                    <ProductSearchDiagnosticsTabs selectedProduct={selectedProduct}/>}

                                {effectiveActiveTabKey === 'admin' && isAdmin() &&
                                    <ProductAdminAction selectedProduct={selectedProduct}
                                                searchCompetitorsOnWebsite={searchCompetitorsOnWebsite}
                                                refreshProducts={refreshProductsMust} getShippingPrices={getShippingPrices}
                                                getProductReviews={getProductReviews} getProductFailedReviews={getProductFailedReviews}
                                                autoMatchProductSuggestions={autoMatchProductSuggestions}/>}
                            </div>
                        </div>
                    </GlobalHotKeys>
                    : <></>}
            </React.Fragment>;

};
export default ProductDetail;
